import {Component, ViewEncapsulation} from "@angular/core";
import {SettingsService} from "../../../shared/settings.service";

@Component({
    selector: 'hc-header',
    templateUrl: './hc-header.component.html',
    styleUrls: ['./hc-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class HcHeaderComponent {
    constructor(public settings: SettingsService) {}
}



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/app/help-center/front/hc-header/hc-header.component.ts